import script from "./ContactDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactDialog.vue?vue&type=script&lang=ts&setup=true"

import "./ContactDialog.vue?vue&type=style&index=0&id=7ebe5b11&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ebe5b11"]])

export default __exports__